import React from 'react'
import { Layout } from '../'

const Gallery = props => (
  <Layout nospacing wide darkCloseButton>
    <img src={props.data.images[0]} alt="" style={{ maxWidth: '100%', display: 'block' }} />
  </Layout>
)

export default Gallery
